import { FunnelIcon as Funnel } from "@phosphor-icons/react";
import { CONFIDENCES, ORIGINS, REFERENCE_TYPES, originLabel, typeLabel } from "@/lib/fieldDependencyConstants";

const sel = "ml-mono text-xs px-2 py-1.5 border border-[var(--ml-border)] bg-white";

/** Filter bar for the field reference table (Iter 41). `filters` is URL-backed by the page. */
export default function FieldRefFilters({ filters, onChange, onClear }) {
  const set = (k, v) => onChange({ ...filters, [k]: v });
  const active = Object.entries(filters).some(([k, v]) => k !== "offset" && v);
  return (
    <div className="ml-card p-3 flex flex-wrap items-center gap-2" data-testid="fd-filters">
      <input
        type="text"
        value={filters.q || ""}
        onChange={(e) => set("q", e.target.value)}
        placeholder="Search field, program, file or excerpt"
        data-testid="fd-search"
        className="ml-mono text-xs flex-1 min-w-[200px] px-2 py-1.5 border border-[var(--ml-border)] focus:outline-none focus:border-[var(--ml-primary)]"
      />
      <input
        type="text"
        value={filters.program || ""}
        onChange={(e) => set("program", e.target.value.toUpperCase())}
        placeholder="Program"
        data-testid="fd-filter-program"
        className="ml-mono text-xs w-32 px-2 py-1.5 border border-[var(--ml-border)] uppercase"
      />
      <input
        type="text"
        value={filters.file || ""}
        onChange={(e) => set("file", e.target.value.toUpperCase())}
        placeholder="File"
        data-testid="fd-filter-file"
        className="ml-mono text-xs w-28 px-2 py-1.5 border border-[var(--ml-border)] uppercase"
      />
      <input
        type="text"
        value={filters.display_file && filters.display_file !== "*ANY" ? filters.display_file : ""}
        onChange={(e) => set("display_file", e.target.value.toUpperCase())}
        placeholder="Display file"
        data-testid="fd-filter-display-file"
        className="ml-mono text-xs w-32 px-2 py-1.5 border border-[var(--ml-border)] uppercase"
      />
      <select value={filters.reference_type || ""} onChange={(e) => set("reference_type", e.target.value)} className={sel} data-testid="fd-filter-type">
        <option value="">All types</option>
        {REFERENCE_TYPES.map((t) => <option key={t} value={t}>{typeLabel(t)}</option>)}
      </select>
      <select value={filters.origin || ""} onChange={(e) => set("origin", e.target.value)} className={sel} data-testid="fd-filter-origin">
        <option value="">All origins</option>
        {ORIGINS.map((o) => <option key={o} value={o}>{originLabel(o)}</option>)}
      </select>
      <select value={filters.confidence || ""} onChange={(e) => set("confidence", e.target.value)} className={sel} data-testid="fd-filter-confidence">
        <option value="">All confidence</option>
        {CONFIDENCES.map((c) => <option key={c} value={c}>{c}</option>)}
      </select>
      <label className="inline-flex items-center gap-1.5 text-xs cursor-pointer select-none">
        <input
          type="checkbox"
          checked={filters.ambiguous === "true"}
          onChange={(e) => set("ambiguous", e.target.checked ? "true" : "")}
          data-testid="fd-filter-ambiguous"
        />
        Ambiguous only
      </label>
      <label className="inline-flex items-center gap-1.5 text-xs cursor-pointer select-none" title="Only display-file (DSPF) field references">
        <input
          type="checkbox"
          checked={filters.display_file === "*ANY"}
          onChange={(e) => set("display_file", e.target.checked ? "*ANY" : "")}
          data-testid="fd-filter-screen-only"
        />
        Screen fields only
      </label>
      {active && (
        <button type="button" onClick={onClear} data-testid="fd-clear-filters"
          className="ml-mono text-[10px] uppercase tracking-widest text-[var(--ml-primary)] hover:underline px-2 inline-flex items-center gap-1">
          <Funnel size={11} weight="bold" /> Clear ×
        </button>
      )}
    </div>
  );
}
